import { RowType } from '../Row/RowType.csharp';
import { PictureProfiles } from '~/Partials/Picture/PictureProfiles';

export const getDefaultPictureProfile = (rowType: RowType) => {
    switch (rowType) {
        case RowType.OneOnOne:
            return PictureProfiles.contentCard;
        case RowType.OneLeftAndTwoOnTwoRight:
            return PictureProfiles.sixOfTwelveColumnsElementHorizontal;
        default:
            return PictureProfiles.threeOfTwelveColumnsElementHorizontal;
    }
};

export const getFirstPosterPictureProfile = (rowType: RowType) => {
    switch (rowType) {
        case RowType.OneLeftAndFourOnOneRight:
            return PictureProfiles.horizontal;
        case RowType.OneLeftAndTwoOnTwoRight:
            return PictureProfiles.mainPosterVertical;
        default:
            return getDefaultPictureProfile(rowType);
    }
};
